/* Isla Pan · Compra rápida: un producto o una categoría completa, extras y paso directo al pago. */
(function () {
  if (window.ipCompraRapida) return;
  window.ipCompraRapida = true;

  var raiz = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var pesos = function (c) { return '$' + Math.round(c / 100).toLocaleString('es-CL'); };
  var catalogo = [], dlg, modo = 'uno', actual = null, cant = 1, cantCat = {}, extras = {}, enCat = [];
  var reducido = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function $(s) { return dlg.querySelector(s); }
  function porId(id) { return catalogo.filter(function (x) { return String(x.id) === String(id); })[0]; }

  /* Bloquea el scroll de la página de atrás (también en iPhone) */
  var scrollY = 0;
  function bloquear() {
    scrollY = window.scrollY || window.pageYOffset;
    var barra = window.innerWidth - document.documentElement.clientWidth;
    document.documentElement.classList.add('ip-cr-bloqueo');
    var b = document.body.style;
    b.position = 'fixed'; b.top = -scrollY + 'px'; b.left = '0'; b.right = '0'; b.width = '100%';
    if (barra > 0) b.paddingRight = barra + 'px';
  }
  function desbloquear() {
    if (!document.documentElement.classList.contains('ip-cr-bloqueo')) return;
    document.documentElement.classList.remove('ip-cr-bloqueo');
    var b = document.body.style;
    b.position = ''; b.top = ''; b.left = ''; b.right = ''; b.width = ''; b.paddingRight = '';
    window.scrollTo(0, scrollY);
  }

  function cerrar() {
    if (!dlg.open || dlg.classList.contains('is-cerrando')) return;
    if (reducido) { dlg.close(); return; }
    dlg.classList.add('is-cerrando');
    setTimeout(function () { dlg.classList.remove('is-cerrando'); dlg.close(); }, 260);
  }

  function cargar() {
    var nodo = document.querySelector('[data-ip-catalogo]');
    dlg = document.querySelector('[data-ip-cr]');
    if (!nodo || !dlg) return false;
    try { catalogo = JSON.parse(nodo.textContent); } catch (e) { catalogo = []; }
    dlg.querySelectorAll('[data-ip-cr-cerrar]').forEach(function (b) { b.addEventListener('click', cerrar); });
    dlg.addEventListener('click', function (e) { if (e.target === dlg) cerrar(); });
    dlg.addEventListener('cancel', function (e) { e.preventDefault(); cerrar(); });
    dlg.addEventListener('close', desbloquear);
    $('[data-ip-cr-menos]').addEventListener('click', function () { cant = Math.max(1, cant - 1); pintarTotal(); });
    $('[data-ip-cr-mas]').addEventListener('click', function () { cant = Math.min(30, cant + 1); pintarTotal(); });
    $('[data-ip-cr-pagar]').addEventListener('click', pagar);
    return true;
  }

  function contar() {
    var n = 0, total = 0;
    if (modo === 'uno') { n = cant; total = actual.p * cant; }
    else enCat.forEach(function (p) { var q = cantCat[p.id] || 0; n += q; total += p.p * q; });
    Object.keys(extras).forEach(function (k) { var x = extras[k]; if (x && x.q > 0) { n += x.q; total += x.s.p * x.q; } });
    return { n: n, total: total };
  }

  function pintarTotal() {
    if (modo === 'uno') $('[data-ip-cr-cant]').textContent = cant;
    var r = contar();
    $('[data-ip-cr-total]').textContent = pesos(r.total);
    $('[data-ip-cr-resumen]').textContent = r.n ? 'Total · ' + r.n + (r.n === 1 ? ' producto' : ' productos') : 'Total';
    $('[data-ip-cr-pagar]').setAttribute('aria-disabled', String(r.n === 0));
  }

  function pintarExtras(excluir) {
    var lista = $('[data-ip-cr-lista]'); lista.innerHTML = '';
    /* Sugiere primero productos de OTRAS categorías (si lleva salado, le ofrece dulce) y varía el orden cada vez */
    var GEN = ['frontpage', 'panes-y-dulces-venezolanos', 'all'];
    var cols = {};
    catalogo.forEach(function (x) { if (excluir.indexOf(x.id) !== -1) (x.c || []).forEach(function (h) { if (GEN.indexOf(h) === -1) cols[h] = 1; }); });
    var cand = catalogo.filter(function (x) { return x.ok && excluir.indexOf(x.id) === -1; });
    cand.forEach(function (x) { x._r = Math.random(); x._m = (x.c || []).some(function (h) { return cols[h]; }) ? 1 : 0; });
    cand.sort(function (a, b) { return (a._m - b._m) || (a._r - b._r); });
    var sug = cand.slice(0, 3);
    $('[data-ip-cr-extra-wrap]').hidden = sug.length === 0;
    sug.forEach(function (s) {
      extras[s.id] = { s: s, q: 0 };
      var fila = document.createElement('div');
      fila.className = 'ip-cr__item';
      fila.innerHTML =
        '<div class="ip-cr__item-foto">' + (s.img ? '<img src="' + s.img + '" alt="" loading="lazy">' : '') + '</div>' +
        '<div class="ip-cr__item-info"><div class="ip-cr__item-nombre"></div><div class="ip-cr__item-precio">' + pesos(s.p) + ' c/u</div>' +
        '<div class="ip-cr__qty ip-cr__qty--mini"><button type="button" data-m>\u2212</button><span aria-live="polite" data-v>0</span><button type="button" data-s>+</button></div></div>';
      fila.querySelector('.ip-cr__item-nombre').textContent = s.t;
      var v = fila.querySelector('[data-v]');
      var m = fila.querySelector('[data-m]'), mas = fila.querySelector('[data-s]');
      m.setAttribute('aria-label', 'Quitar uno de ' + s.t);
      mas.setAttribute('aria-label', 'Agregar uno de ' + s.t);
      var pintar = function () { v.textContent = extras[s.id].q; fila.classList.toggle('is-elegido', extras[s.id].q > 0); pintarTotal(); };
      m.addEventListener('click', function () { extras[s.id].q = Math.max(0, extras[s.id].q - 1); pintar(); });
      mas.addEventListener('click', function () { extras[s.id].q = Math.min(30, extras[s.id].q + 1); pintar(); });
      lista.appendChild(fila);
    });
  }

  function prepararComun() {
    extras = {};
    $('[data-ip-cr-error]').hidden = true;
    var btn = $('[data-ip-cr-pagar]'); btn.disabled = false; btn.textContent = 'Ir a pagar';
  }
  function mostrar() {
    pintarTotal();
    dlg.classList.remove('is-cerrando');
    var caja = $('.ip-cr__caja'); if (caja) caja.scrollTop = 0;
    bloquear();
    if (typeof dlg.showModal === 'function') dlg.showModal(); else dlg.setAttribute('open', '');
  }

  function abrirUno(id) {
    var p = porId(id);
    if (!p || !p.ok) return;
    modo = 'uno'; actual = p; cant = 1;
    prepararComun();
    $('[data-ip-cr-uno]').hidden = false; $('[data-ip-cr-cat]').hidden = true;
    dlg.setAttribute('aria-labelledby', 'ip-cr-titulo');
    $('[data-ip-cr-titulo]').textContent = p.t;
    $('[data-ip-cr-detalle]').textContent = p.d || '';
    $('[data-ip-cr-precio]').textContent = pesos(p.p);
    $('[data-ip-cr-foto]').innerHTML = p.img ? '<img src="' + p.img + '" alt="">' : '';
    pintarExtras([p.id]);
    mostrar();
  }

  function abrirCategoria(handle, nombre) {
    enCat = catalogo.filter(function (x) { return (x.c || []).indexOf(handle) !== -1; });
    if (!enCat.length) return false;
    modo = 'cat'; cantCat = {};
    prepararComun();
    $('[data-ip-cr-uno]').hidden = true; $('[data-ip-cr-cat]').hidden = false;
    var tit = $('[data-ip-cr-cat-titulo]'); tit.textContent = nombre || '';
    tit.id = 'ip-cr-cat-titulo'; dlg.setAttribute('aria-labelledby', 'ip-cr-cat-titulo');

    var primero = enCat.filter(function (x) { return x.ok; })[0];
    var lista = $('[data-ip-cr-cat-lista]'); lista.innerHTML = '';
    enCat.forEach(function (p) {
      if (p.ok) cantCat[p.id] = p === primero ? 1 : 0;
      var fila = document.createElement('div');
      fila.className = 'ip-cr__cat-item' + (p.ok ? '' : ' is-agotado');
      fila.innerHTML =
        '<div class="ip-cr__cat-foto">' + (p.img ? '<img src="' + p.img + '" alt="" loading="lazy">' : '') + '</div>' +
        '<div><div class="ip-cr__cat-nombre"></div><div class="ip-cr__cat-precio">' + pesos(p.p) + '</div></div>' +
        (p.ok
          ? '<div class="ip-cr__qty"><button type="button" data-m>−</button><span aria-live="polite" data-v>0</span><button type="button" data-s>+</button></div>'
          : '<span class="ip-cr__agotado ip-cr__cat-precio">Agotado hoy</span>');
      fila.querySelector('.ip-cr__cat-nombre').textContent = p.t;
      if (p.ok) {
        var v = fila.querySelector('[data-v]');
        var pintar = function () { v.textContent = cantCat[p.id]; fila.classList.toggle('is-elegido', cantCat[p.id] > 0); pintarTotal(); };
        fila.querySelector('[data-m]').setAttribute('aria-label', 'Quitar uno de ' + p.t);
        fila.querySelector('[data-s]').setAttribute('aria-label', 'Agregar uno de ' + p.t);
        fila.querySelector('[data-m]').addEventListener('click', function () { cantCat[p.id] = Math.max(0, cantCat[p.id] - 1); pintar(); });
        fila.querySelector('[data-s]').addEventListener('click', function () { cantCat[p.id] = Math.min(30, cantCat[p.id] + 1); pintar(); });
        v.textContent = cantCat[p.id];
        fila.classList.toggle('is-elegido', cantCat[p.id] > 0);
      }
      lista.appendChild(fila);
    });
    pintarExtras(enCat.map(function (x) { return x.id; }));
    mostrar();
    return true;
  }

  function pagar() {
    var btn = $('[data-ip-cr-pagar]');
    if (btn.getAttribute('aria-disabled') === 'true') return;
    var items = [];
    if (modo === 'uno') items.push({ id: actual.v, quantity: cant });
    else enCat.forEach(function (p) { if (cantCat[p.id] > 0) items.push({ id: p.v, quantity: cantCat[p.id] }); });
    Object.keys(extras).forEach(function (k) { var x = extras[k]; if (x && x.q > 0) items.push({ id: x.s.v, quantity: x.q }); });
    if (!items.length) return;
    btn.disabled = true; btn.textContent = 'Preparando tu pedido…';
    fetch(raiz + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) { if (!r.ok) throw r; window.location.href = raiz + 'checkout'; })
      .catch(function () { btn.disabled = false; btn.textContent = 'Ir a pagar'; $('[data-ip-cr-error]').hidden = false; });
  }

  function iniciar() {
    if (!cargar()) return;
    document.addEventListener('click', function (e) {
      var c = e.target.closest('[data-ip-categoria]');
      if (c) {
        if (abrirCategoria(c.getAttribute('data-ip-categoria'), c.getAttribute('data-ip-cat-nombre'))) e.preventDefault();
        return;
      }
      var b = e.target.closest('[data-ip-comprar]');
      if (!b) return;
      e.preventDefault();
      abrirUno(b.getAttribute('data-ip-comprar'));
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar); else iniciar();
})();
